module.exports = __webpack_public_path__ + "static/media/undraw_Hello_qnas.fe8ba129.svg";